import script from "./ClaimForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClaimForm.vue?vue&type=script&lang=ts&setup=true"

import "./ClaimForm.vue?vue&type=style&index=0&id=54281dce&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/blueshift-vesting-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54281dce"]])

export default __exports__